/* Brand payment marks — used on the booking page, splash & footer */

const badgeCls = "inline-flex items-center justify-center px-2.5 py-1.5 rounded-md text-[10px] font-semibold tracking-tight select-none";

export function ApplePayBadge({ className = "" }) {
  return (
    <span data-testid="badge-apple-pay" aria-label="Apple Pay accepted" className={`${badgeCls} bg-black text-white ${className}`}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" className="mr-1">
        <path d="M19.665 16.811a10.316 10.316 0 0 1-1.021 1.837c-.537.767-.978 1.297-1.316 1.592-.525.482-1.089.73-1.692.744-.432 0-.954-.123-1.562-.373-.61-.249-1.17-.371-1.683-.371-.537 0-1.113.122-1.73.371-.616.25-1.114.381-1.495.394-.577.025-1.154-.229-1.729-.764-.367-.32-.826-.87-1.377-1.648-.59-.83-1.075-1.794-1.455-2.891-.407-1.187-.611-2.335-.611-3.447 0-1.273.275-2.372.826-3.292a4.857 4.857 0 0 1 1.73-1.751 4.65 4.65 0 0 1 2.34-.662c.46 0 1.063.142 1.81.422.749.281 1.23.422 1.439.422.157 0 .69-.166 1.601-.495.86-.305 1.586-.431 2.18-.381 1.61.13 2.819.766 3.62 1.91-1.438.872-2.149 2.094-2.135 3.662.013 1.221.456 2.237 1.327 3.048a4.36 4.36 0 0 0 1.397.929c-.114.353-.236.694-.376 1.022zM15.998 2.38c0 .95-.348 1.838-1.039 2.659-.836.976-1.846 1.541-2.941 1.452a2.951 2.951 0 0 1-.022-.36c0-.913.397-1.889 1.103-2.688.352-.404.8-.741 1.343-1.009.542-.264 1.054-.41 1.536-.435.013.128.02.256.02.381z" />
      </svg>
      Pay
    </span>
  );
}

export function GooglePayBadge({ className = "" }) {
  return (
    <span data-testid="badge-google-pay" aria-label="Google Pay accepted" className={`${badgeCls} bg-white border border-zinc-300 text-zinc-900 ${className}`}>
      <span className="mr-1 flex">
        <span style={{ color: "#4285F4" }}>G</span>
      </span>
      Pay
    </span>
  );
}

export function VisaBadge({ className = "" }) {
  return (
    <span data-testid="badge-visa" aria-label="Visa accepted" className={`${badgeCls} bg-white border border-zinc-300 font-bold text-[#1A1F71] italic ${className}`}>
      VISA
    </span>
  );
}

export function MastercardBadge({ className = "" }) {
  return (
    <span data-testid="badge-mastercard" aria-label="Mastercard accepted" className={`${badgeCls} bg-white border border-zinc-300 gap-0.5 px-3 ${className}`}>
      <span className="w-3 h-3 rounded-full bg-[#EB001B] -mr-1.5 opacity-90" />
      <span className="w-3 h-3 rounded-full bg-[#F79E1B] opacity-90 mix-blend-multiply" />
    </span>
  );
}

export function AmexBadge({ className = "" }) {
  return (
    <span data-testid="badge-amex" aria-label="American Express accepted" className={`${badgeCls} bg-[#016FD0] text-white font-bold tracking-wider ${className}`}>
      AMEX
    </span>
  );
}

export default function PaymentBadges({ size = "md", className = "" }) {
  const scale = size === "sm" ? "scale-90" : size === "lg" ? "scale-110" : "";
  return (
    <div data-testid="payment-badges" className={`flex items-center gap-1.5 flex-wrap ${scale} ${className}`}>
      <VisaBadge />
      <MastercardBadge />
      <AmexBadge />
      <ApplePayBadge />
      <GooglePayBadge />
    </div>
  );
}
